import React from "react";
import AdminLogs from "../views/AdminLogs";

/** Renders the Administrator logs UI with in-memory mock data (no Auth0 / backend). */
export default function AdminLogsWalkthroughShell() {
  return (
    <div data-testid="admin-logs-walkthrough-shell">
      <AdminLogs />
    </div>
  );
}
